import React from 'react';
import { Box, Typography } from '@mui/material';
import { TooltipedIcon } from '@europrocurement/flexy-components';
import { demoIcon } from '@europrocurement/l2d-icons';

export type DossierPrescriberProps = {
    label: string;
    demo?: boolean | null;
};

const DossierPrescriber: React.FunctionComponent<DossierPrescriberProps> = function ({
    label,
    demo,
}) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            {demo && (
                <TooltipedIcon
                    icon={demoIcon}
                    tooltip="Démo"
                    size="xs"
                    color="error"
                />
            )}
            <Typography
                variant="l2dtableCell"
                color="text.gris70"
            >
                {label}
            </Typography>
        </Box>
    );
};

export default DossierPrescriber;
